// auth-config.ts
import { LogLevel } from 'angular-auth-oidc-client';
import { environment as ENV } from '../environments/environment';

export const openIdConfig = {
  authority: ENV.openIdDict.authority, 
  redirectUrl: ENV.openIdDict.redirectUri, 
  clientId: ENV.openIdDict.clientId,
  scope: 'openid profile email offline_access api_central api_dmanalytics',
  responseType: 'code',
  silentRenew: true,
  useRefreshToken: true,
  // Margem para o refresh acontecer antes do access token expirar
  renewTimeBeforeTokenExpiresInSeconds: 90,
  // Sem isto, o id_token expirado força novo login mesmo com refresh token válido
  triggerRefreshWhenIdTokenExpired: false,
  // IdPs (Duende/IdentityServer) não devolvem nonce no refresh; sem isto o renew falha
  ignoreNonceAfterRefresh: true,
  // Tenta novamente antes de derrubar a sessão em falha transitória de rede
  refreshTokenRetryInSeconds: 3,
  postLogoutRedirectUri: ENV.openIdDict.logout,
  postLoginRoute: '/home',
  maxIdTokenIatOffsetAllowedInSeconds: 300, 
  secureRoutes: [
    ENV.apiDMA.uri,
    ENV.apiDMDI?.uri ?? '',
    ENV.apiBaseUrl,
    'http://localhost:4200/api',
    `${ENV.apiBaseUrl}/api`
  ].map(r => r.endsWith('/') ? r.slice(0, -1) : r)
   .filter(r => r.length > 0),
  logLevel: ENV.production ? LogLevel.Error : LogLevel.Debug,
};
